<!-- eslint-disable vue/html-self-closing -->
<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <section
          v-if="Object.keys(issue)?.length > 0"
          class="issue-overview-layout"
        >
          <issue-header class="issue-overview-layout__header"></issue-header>
          <div class="issue-overview-layout__content">
            <router-view></router-view>
          </div>
        </section>
        <section
          v-else
          class="issue-overview-layout"
        >
          <pacman-loader />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import IssueMessages from '@shared/modules/issue/issue.messages';
import IssueHeader from '@shared/modules/issue/components/item/IssueHeader';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
import IssueService from '@shared/modules/issue/issue.service';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'IssueOverviewLayout',
  components: { IssueHeader, PacmanLoader },
  data() {
    return {};
  },
  computed: {
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    issueId() {
      return this.$route.params?.issueId;
    },
    issue() {
      return this.$store.getters.getIssue || {};
    }
  },
  mounted() {
    this.getIssue();
    this.getIssueDiscussionsCounter();
  },
  methods: {
    getIssue() {
      IssueService.getIssue(this.alias, this.projectAlias, this.issueId);
    },
    getIssueDiscussionsCounter() {
      IssueService.getDiscussionCounterValue(this.alias, this.projectAlias, this.issueId);
    }
  },
  i18n: {
    messages: IssueMessages
  }
};
</script>

<style lang="scss">
$this: '.issue-overview-layout';

#{$this} {
  min-height: 100px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;

  #{$this}__content {
    min-height: 200px;
    position: relative;
  }
}
</style>
